module.exports = __webpack_public_path__ + "img/zonnestroom-5sterren-google.32fff9c7.png";